import { getLanguage } from "../Managers/dataProvider";
import { EmployeeDailyLogModel } from "../Managers/dataStructures";
import { getCurrentCurrency } from "../Managers/profileManager";
import { serverDateStringToRegularDateString } from "../Managers/utilityFunctions";

interface EmployeeHistroyReportProps {
  array_daily_logs: EmployeeDailyLogModel[];
}

export default function EmployeeHistoryReport(
  props: EmployeeHistroyReportProps
) {
  const isEnglish = getLanguage();
  return (
    <div className="px-2 sm:px-4 lg:px-4">
      <div className="mt-8 flow-root">
        <div className="mt-5 mb-5 text-base font-semibold leading-6 text-gray-900"></div>
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr className="divide-x divide-gray-200">
                  <th
                    scope="col"
                    className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                  >
                    {isEnglish ? "Date" : "Datum"}
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    {isEnglish ? "Branch" : "Filiale"}
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    {isEnglish
                      ? "Start Time - End Time"
                      : "Arbeitsbeginn- Arbeitsende"}
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    {isEnglish
                      ? "Total Hours - Break Hours"
                      : "Gesamtstunden – Pausenstunden"}
                  </th>

                  <th
                    scope="col"
                    className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pr-0"
                  >
                    {isEnglish ? "Total Earnings" : "Summe Arbeitslohn"}
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {props.array_daily_logs.map((x) => CellReportDetail(x))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

function CellReportDetail(item: EmployeeDailyLogModel) {
  function formatTime(date: string) {
    if (date === undefined || date === null) {
      return "N/A";
    }
    const chunks = date.split(" ");

    for (let i = 0; i < chunks.length; i++) {
      if (chunks[i].search(":") !== -1) {
        return chunks[i];
      }
    }
    return "N/A";
  }

  const startTime: string = formatTime(item.array_entries[0].start_time);
  let endTime: string | undefined =
    item.array_entries[item.array_entries.length - 1].end_time;
  if (endTime !== undefined) {
    endTime = formatTime(endTime);
  }
  return (
    <tr className="divide-x divide-gray-200" key={item.shift_date}>
      <td className="whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-gray-900 sm:pl-0">
        <div>
          <div>{serverDateStringToRegularDateString(item.shift_date)}</div>
        </div>
      </td>
      <td className="whitespace-nowrap p-4 text-sm text-gray-500">
        <div>
          <div> {item.branch_name}</div>
        </div>
      </td>
      <td className="whitespace-nowrap p-4 text-sm text-gray-500">
        <div>
          <div> {startTime}</div>
          <div> {endTime}</div>
        </div>
      </td>
      <td className="whitespace-nowrap p-4 text-sm text-gray-500 max-w-[200px] overflow-ellipsis overflow-clip">
        <div>
          <div> {item.total_hours}</div>
          <div> {item.break_hours}</div>
        </div>
      </td>
      <td className="whitespace-nowrap py-4 pl-4 pr-4 text-sm text-gray-500 sm:pr-0">
        {getCurrentCurrency() + item.earning}
      </td>
    </tr>
  );
}
